import { TriggerText } from './TriggerText';

// TODO: in v9, move styled() from TriggerText.jsx to here
export var StyledTriggerText = TriggerText;